<template>
  <dashboard-page title="Notas Fiscais">
    <div class="content">
    <base-header>
      <b-row align-h="start">
        <b-col>
          <date-picker v-model="formDate.startDate" size="large" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd"
            :clearable="false">
          </date-picker>
        </b-col>

        <b-col>
          <date-picker v-model="formDate.endDate" size="large" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd"
            :clearable="false">
          </date-picker>
        </b-col>

        <b-col class="ml-3 pb-3 text-right">
          <base-button :loading="loadingTable" type="submit" class="btn btn-primary">Buscar</base-button>
        </b-col>
      </b-row>
    </base-header>
  </div>
  </dashboard-page>
</template>

<script>
import { DatePicker } from "element-ui";
import bocapioService from "./../../services/nodejs/index";
import cakeService from "./../../services/cakephp/index";

export default {
    component: 'NotaFiscal',

    components:{
        DatePicker,
    },

    mounted(){
        this.fillsFormDate();
        this.formURL = `https://apps.bocapio.com.br/panel/templates/nfe/nfe.html?as=bsf`
        
    },

    data: () =>{
        return {
            formDate: { startDate: "2022-01-01", endDate: "2022-01-31" },
            loadingTable: false,
            formURL: ''
        }
    },

    computed:{

    },

    methods:{
        fillsFormDate(){
            let date = new Date();
            let firstDateMoth = new Date(date.getFullYear(), date.getMonth(), 1);
            let m = firstDateMoth.getMonth() + 1;
            let d = firstDateMoth.getDate();
            d = d > 9 ? d : "0" + d;
            m = m > 9 ? m : "0" + m;

            let todayDay = date.getDate();
            let todayMonth = date.getMonth() + 1;
            todayDay = todayDay > 9 ? todayDay : "0" + todayDay;
            todayMonth = todayMonth > 9 ? todayMonth : "0" + todayMonth;

            let formatedFirstDayMonth = date.getFullYear() + "-" + m + "-" + d;
            let formatedToday = date.getFullYear() + "-" + todayMonth + "-" + todayDay;
            if(process.env.NODE_ENV === "development"){
                formatedFirstDayMonth = (date.getFullYear()) + "-" + m + "-" + d;
                formatedToday = (date.getFullYear()) + "-" + todayMonth + "-" + todayDay;
            }
            this.formDate.startDate = formatedFirstDayMonth;
            this.formDate.endDate = formatedToday; 
        },


    },


}
</script>
